<template>
    <div class="main-cn">
        <div class="main-bd mg20">
            <el-row class="searchSection">
                <SearchForm 
                :params="searcheModel" 
                :fields="fields" 
                :cache_field="'search_config_' + active_name + '_' + this.$route.path" 
                @search="submitSearch" 
                @reset="resetForm" 
                :key="search_form_key"> 
                </SearchForm>
            </el-row>
            <el-row class="addBtn">
                <ExportFile 
                    url="/api/export/refund-product" 
                    :params="searcheModel" 
                    filename="退款产品记录" 
                    buttonName="导出Excel">
                </ExportFile>
            </el-row>
            <el-row v-loading="loading">
                <el-table 
                v-if="!loading"
                :data="list" 
                border>
                    <el-table-column prop="product_name" label="退款产品"></el-table-column>
                    <el-table-column prop="customer_name" label="客户名称"></el-table-column>
                    <el-table-column prop="customer_user_name" label="客户绑定人"></el-table-column>
                    <el-table-column prop="district_names" label="所在地区"></el-table-column>
                    <el-table-column prop="memo" label="退款原因"></el-table-column>
                    <el-table-column prop="refund_amount" label="退款金额"></el-table-column>
                    <el-table-column prop="order_id" label="订单ID">
                        <template slot-scope="scope">
                            <el-button type="text" @click="handleView(scope.row)">
                                {{ scope.row.order_id }}
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="order_branch_name" label="所在部门"></el-table-column>
                    <el-table-column prop="order_user_name" label="订单负责人"></el-table-column>
                    <el-table-column prop="created_at" label="退款时间"></el-table-column>
                </el-table>
                <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
            </el-row>
        </div>
    </div>
</template>
<script>
import CustomerService from "~/services/customer";
import SearchForm from "~/widgets/SearchForm.vue";
import MyPagination from "~/widgets/MyPagination.vue";
import ExportFile from "~/widgets/ExportFile.vue";
export default {
    name: "refundProduct",

    components: {
        SearchForm,
        MyPagination,
        ExportFile
    },

    props: {},

    data() {
        return {
            loading: false,
            searcheModel: {},
            // 分页信息
            linkPage: null,
            list: [],
            fields: [],
            search_form_key: 0,
            active_name: 'refund-product'
        };
    },

    mounted() {},

    created: function () {
        this.resetForm();
    },

    methods: {
        //重置按钮
        resetForm() {
            this.fields = [
                {field: 'base', label: '基础信息筛选条件', children: [
                    {field: 'product_id', label: '产品筛选', type: 'components', ref: 'product', components: 'Product', change: 'getValue'},
                    {field: 'name', label: '客户名称', type: 'components', ref: 'customer', components: 'CustomerSelect', change: 'changeObjValue'},
                    {field: 'salesman', label: '订单负责人', type: 'components', ref: 'user', components: 'UserSelect', change: 'changeObjValue'},
                    {field: 'branch_id', label: '所属部门', type: 'components', ref: 'branch', components: 'UserCascader', change: 'changeCascaderLast'},
                    {field: 'memo', label: '退款原因', type: 'input'},
                ]},
                {field: 'date', label: '时间筛选条件', children: [
                    {field: 'created_at', label: '退款时间', type: 'daterange'},
                ]},
            ];
            this.searcheModel = {};
            this.list = [];
            this.search_form_key ++;
            this.submitSearch();
        },

        // 筛选查询
        submitSearch(params = null) {
            if(params){
                this.searcheModel = params;
            }
            params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            //请求侧边栏地区树
            this.getList(params);
        },

        //获取列表
        getList(params) {
            // loading 动画
            this.loading = true;
            CustomerService.getRefundProduct(params).then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                if (res._meta) {
                    this.linkPage = res._meta;
                }
                this.loading = false;
            }).catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },

        handleSizeChange(newSize) {
            // 处理每页条目数变化事件
            this.searcheModel['perPage'] = newSize;
            this.submitSearch();
        },

        handleCurrentChange(newPage) {
            // 处理当前页码变化事件
            this.searcheModel['page'] = newPage;
            this.submitSearch();
        },
        handleView(row) {
            let routeData = this.$router.resolve({
                path: "/order/view",
                query: {id: row.order_id},
            });
            window.open(routeData.href, '_blank');
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/views/customer/refundProduct.vue